import ko from "knockout";

export function registerKnockoutBinding(name: string, bindingHandler: KnockoutBindingHandler) {
    if (ko.bindingHandlers[name] !== undefined) {
        throw new Error(`There is already a knockout binding with name ${name} registered!`);
    }

    ko.bindingHandlers[name] = bindingHandler;
}

export function overrideKnockoutBinding(name: string, bindingHandler: KnockoutBindingHandler) {
    ko.bindingHandlers[name] = bindingHandler;
}

export function registerKnockoutExtension(name: string, extensionHandler: any) {
    const extensionPoint = ko.extenders as any;

    if (extensionPoint[name] !== undefined) {
        throw new Error(`There is already a knockout extension with name ${name} registered!`);
    }

    extensionPoint[name] = extensionHandler;
}

export function overrideKnockoutExtension(name: string, extensionHandler: any) {
    const extensionPoint = ko.extenders as any;
    extensionPoint[name] = extensionHandler;
}

export default {
    registerKnockoutBinding: registerKnockoutBinding,
    overrideKnockoutBinding: overrideKnockoutBinding,
    registerKnockoutExtension: registerKnockoutExtension,
    overrideKnockoutExtension: overrideKnockoutExtension
};
